import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

type ResetGovernmentAllocationDistributionsProps = {
  governmentAllocationId?: string
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useResetGovernmentAllocationDistributions = ({
  governmentAllocationId,
  onSuccess,
  onError,
}: ResetGovernmentAllocationDistributionsProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['resetGovernmentAllocationDistributions', governmentAllocationId],
    mutationFn: async () => {
      return privateAxios.put(
        `/billing/government_allocations/${governmentAllocationId}/reset_remaining_distributions`,
      )
    },
    onSuccess,
    onError,
  })
}
